import { render } from "./phoneDetail.vue?vue&type=template&id=191ffc1f"
import script from "./phoneDetail.vue?vue&type=script&lang=js"
export * from "./phoneDetail.vue?vue&type=script&lang=js"

import "./phoneDetail.vue?vue&type=style&index=0&id=191ffc1f&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__